import { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import { sessionsSelectors } from 'features/sessions';

const getActualBuilderLink = (accessToken) => {
  if (window.location.hostname.includes('staging') || window.location.hostname.includes('localhost')) {
    return `https://builder-staging.converse.health/${accessToken}`;
  }
  return `https://builder.converse.health/${accessToken}`;
};

const Builder = () => {
  const { accessToken } = useCustomSelector(sessionsSelectors.getManagerSession);
  const url = getActualBuilderLink(accessToken);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  height: '100%' }}>
      <Button href={url} variant="contained" color="primary" target='_blank' rel='noopener noreferrer'>
        Flows list
      </Button>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Builder {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);